export enum RecordStatus {
  Created = 1,
  Active = 2,
  Inactive = 3,
  Deleted = 4
}